import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

/** Add a 'camelCase: true' header to all REST API calls */
@Injectable()
export class CamelCaseInterceptor implements HttpInterceptor {
   intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      let shouldAddHeader: boolean;
      if (req.url.startsWith('/api')) {
         shouldAddHeader = true;
      } else if (req.url.startsWith('assets')) {
         shouldAddHeader = false;
      } else {
         const url = new URL(req.url);
         shouldAddHeader = url.host === location.host && url.pathname.startsWith('/api');
      }

      if (shouldAddHeader) {
         return next.handle(
            req.clone({
               setHeaders: {
                  'qmanage-api-casestrategy': 'camelCase',
               },
            })
         );
      }
      return next.handle(req);
   }
}
